export default class AppointmentList {
  #ui;
  #pagination;
  #selectedDate;
  #defaultDate;

  get eventTarget() {
    return this.#ui.list;
  }

  constructor() {
    this.#pagination = {
      history: [],
      currentStart: "",
      nextStart: "",
    };
  }

  init() {
    this.#cacheUiElements();
    this.#initDatePicker();
    this.#bindEvents();
  }

  show({
    lastPage, start, end, appointments,
  }) {
    this.#ui.list.empty();

    if (appointments.length === 0) {
      const $row = $("<div class=\"appointment py-2\">Sorry, there are no appointments available after the selected date.</div>");
      this.#ui.list.append($row);
    } else {
      $.each(appointments, (i, appointment) => {
        const startTime = moment(appointment.start);
        const $row = $(`<div class="appointment row border-bottom py-2"><div class="col-sm-4 px-0">${startTime.format("ddd DD/MM/YYYY")}</div><div class="col-sm-3 px-0">${startTime.format("h:mm a")}</div><div class="col-sm-5 px-0">${appointment.provider.fullName}</div></div>`);
        $row.attr("data-id", appointment.id);

        this.#ui.list.append($row);

        $row.click(() => {
          const $allRows = this.#ui.list.find(".appointment");
          $allRows.removeClass("active");
          $row.addClass("active");

          this.eventTarget.triggerHandler("select.appointment-list", appointment);
        });
      });

      this.#updatePagination(lastPage, start, end);
    }

    this.#ui.wrap.removeClass("hidden");
    this.#ui.wrap.fadeIn();
    window.scroller.scrollToElemTop(this.#ui.wrap);
  }

  previousPage() {
    const previousStart = this.#pagination.history.pop();
    this.eventTarget.triggerHandler("change.appointment-list", previousStart);
  }

  nextPage() {
    this.#pagination.history.push(this.#pagination.currentStart);
    this.eventTarget.triggerHandler("change.appointment-list", this.#pagination.nextStart);
  }

  reset() {
    const currentDate = this.#ui.datePicker.datetimepicker("date");
    if (!currentDate.isSame(this.#defaultDate)) {
      // Update the date picker (the handler calls this.#updateDate)
      this.#ui.datePicker.datetimepicker("date", this.#defaultDate);
    }
    else {
      // We don't need to update the datepicker control.
      this.#updateDate(this.#defaultDate);
    }
  }

  clear() {
    this.#ui.wrap.fadeOut();
    this.#ui.backButton.fadeOut();
    this.#ui.nextButton.fadeOut();
    this.#ui.list.empty();

    this.#pagination.history = [];
  }

  remove(appointmentId) {
    const $row = this.#ui.list.find(`[data-id='${appointmentId}']`);
    $row.remove();
  }

  #cacheUiElements() {
    this.#ui = {
      datePicker: $("#earliest-date-picker"),
      wrap: $("#select-appointment-wrap"),
      list: $(".appointments"),
      backButton: $("#select-appointment-wrap .btn.back"),
      nextButton: $("#select-appointment-wrap .btn.next"),
    };
  }

  #initDatePicker() {
    this.#defaultDate = moment(this.#ui.datePicker.data("default-date"));

    this.#ui.datePicker.datetimepicker({
      format: "DD/MM/YYYY", // This is the DISPLAY format
      defaultDate: this.#defaultDate,
      minDate: moment(this.#ui.datePicker.data("min-date")),
      maxDate: moment(this.#ui.datePicker.data("max-date")),
    });

    this.#selectedDate = this.#ui.datePicker.datetimepicker("viewDate");
  }

  #bindEvents() {
    this.#ui.backButton.click(() => {
      this.previousPage();
    });

    this.#ui.nextButton.click(() => {
      this.nextPage();
    });

    this.#ui.datePicker.on("change.datetimepicker", (e) => {
      // Update the appointment list
      this.#updateDate(e.date);
    });
  }

  #updateDate(newDate) {
    this.clear();
    this.#selectedDate = newDate;
    this.eventTarget.triggerHandler("change.appointment-list", this.#selectedDate);
  }

  #updatePagination(lastPage, start, end) {
    this.#pagination.currentStart = moment(start).toDate();
    // Next page begins after this page's last appointment
    this.#pagination.nextStart = moment(end).toDate();

    if (this.#isFirstPage()) {
      this.#ui.backButton.fadeOut();
    } else {
      this.#ui.backButton.fadeIn();
    }

    if (lastPage) {
      this.#ui.nextButton.fadeOut();
    } else {
      this.#ui.nextButton.fadeIn();
    }
  }

  #isFirstPage() {
    const min = moment(this.#ui.datePicker.datetimepicker("viewDate"), "DD-MM-YYYY");

    return this.#selectedDate.isSame(min, "day")
      && this.#pagination.history.length === 0;
  }
}
